<lib-app-button data-testid="reset-application-button" id="resetAppDialogButton" fill="clear" size="default">
  {{ 'menu.deviceSettings.resetApplication.resetApplicationButton' | transloco }}
</lib-app-button>

<ion-alert
  trigger="resetAppDialogButton"
  [header]="'menu.deviceSettings.resetApplication.deleteConfirmationDialog.title' | transloco"
  [message]="'menu.deviceSettings.resetApplication.deleteConfirmationDialog.message' | transloco"
  [buttons]="alertButtons"
></ion-alert>
